<template>
    <component 
        class="single landscape" 
        :announcement="this.announcements[0]"
        :refreshPeriod="this.refreshPeriod"
        :isLandscape="true"
        :isParallel="false"
        :is="returnComponent(0)"
        :isPreview="isPreview">
    </component>
</template>

<script>
    import BasicView from "../Templates/BasicView";
    import StudyDepartmentCallIn from "../Templates/StudyDepartmentCallIn";
    import EventPlanService from "../Templates/EventPlanService";
    import LessonPlanService from "../Templates/LessonPlanService";
    import FullScreenImageService from "../Templates/FullScreenImageService";
    import PublicTransportService from "../Templates/PublicTransportService";
    import FoodService from "../Templates/FoodService";

    export default {
        name: "OneParallel",

        props: {
            announcements: Array,
            refreshPeriod: Number,
            isPreview: Boolean
        },

        components: {
            BasicView,
            StudyDepartmentCallIn,
            EventPlanService,
            LessonPlanService,
            FullScreenImageService,
            PublicTransportService,
            FoodService
        },

        methods: {
            returnComponent(num) {
                return this.announcements[num].serviceName !== null ? this.announcements[num].serviceName : "BasicView";
            },
        }
    }
</script>

<style scoped>

    .single {
        width: 100%;
        height: 100%;
    }

</style>
